'use strict';

const GlobalContextBaseView = require('../../global/reactHelpers/GlobalContextBaseView');

const galleryTrackingActions = require('../actions/galleryTrackingActions');

const {GA_LINK_TARGETS} = galleryTrackingActions;
const {classes} = require('../helpers/GalleryConstants');
const {pages, pageUrlLabels} = require('../../profile/TradeProfileConstants');

/**
 * View for Gallery's Photo Details (Right Margin)
 *  - handles changing the photoTitle
 *  - handles changing the photoTags
 *  - handles changing the firm name/url
 *  - handles changing the project name/url
 */
const PhotoDetails = GlobalContextBaseView.extend({
    el: `.${classes.PHOTO_DETAILS}`,
    props: {},
    events: {
        [`click .${classes.PROJECT_LINK}`]: '_onClickProjectLink',
        [`click .${classes.PROJECTS_LINK}`]: '_onClickMoreProjectsLink',
        [`click .${classes.SIMILAR_ITEMS_ALL}`]: '_onClickSimilarItemsLink',
        [`click .${classes.SIMILAR_ITEM_PDP}`]: '_onClickSimilarItem'
    },

    initialize() {
        this.$photoTitle = this.$(`.${classes.PHOTO_TITLE}`);
        this.$photoCaption = this.$(`.${classes.PHOTO_CAPTION}`);
        this.$photoAttributes = this.$(`.${classes.PHOTO_ATTRIBUTES}`);

        this.$projectName = this.$(`.${classes.PROJECT_NAME}`);
        this.$projectLink = this.$(`.${classes.PROJECT_LINK}`);
        this.$projectsLink = this.$(`.${classes.PROJECTS_LINK}`);

        this.$firmName = this.$(`.${classes.FIRM_NAME}`);
        this.$firmLink = this.$(`.${classes.FIRM_LINK}`);
        this.$firmImage = this.$(`.${classes.FIRM_IMAGE}`);

        this.$similarItems = this.$(`.${classes.SIMILAR_ITEMS}`);
        this.$moreProjects = this.$(`.${classes.MORE_PROJECTS}`);
    },

    /**
     * Updates props and calls render
     *  (Note: parent calls passProps() @see GalleryWrapperView.es.js)
     *
     * @param {object} props
     * @param {string} props.photoTitle
     * @param {string} props.photoCaption
     * @param {string} props.similarItemsTemplate
     *
     * @param {string} props.photoFirm.url
     * @param {string} props.photoFirm.name
     * @param {string} props.photoFirm.photo.images.thumb
     *
     * @param {string} props.photoProject.url
     * @param {string} props.photoProject.name
     *
     * @param {array}  props.photoAttrTags
     */
    passProps(props) {
        this.props = props;
        this.render();
    },

    /**
     * Render function
     *  - Updates all details each time the photo is changed
     */
    render() {
        this._updatePhotoData()
            ._updatePhotoFirm()
            ._updatePhotoProject()
            ._updatePhotoAttributeTags();

        return this;
    },

    /**
     * Updates the photo's title and caption
     *
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoData() {
        const {photoTitle, photoCaption} = this.props;
        const prevTemplate = this.$similarItems[0].innerHTML;
        const nextTemplate = this.props.similarItemsTemplate;

        if (prevTemplate !== nextTemplate) {
            this.$similarItems.empty().append(nextTemplate);
        }

        this.$photoTitle.text(photoTitle);
        this.$photoCaption.text(photoCaption);

        return this;
    },

    /**
     * Updates photo's firm name, links and image
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoFirm() {
        const {name, url, photo = {}} = this.props.photoFirm || {};
        const prevTemplate = this.$moreProjects[0].innerHTML;
        const nextTemplate = this.props.moreProjectsTemplate;

        this.$firmName.text(name);
        this.$firmLink.attr('href', url);
        this.$firmImage.attr('src', photo.images.thumb);
        this.$projectsLink.attr('href', `${url}${pageUrlLabels[pages.PROJECTS]}/`);

        if (prevTemplate !== nextTemplate) {
            this.$moreProjects.empty().append(nextTemplate);
        }

        return this;
    },

    /**
     * Updates photo's project name and links
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoProject() {
        const {name, url} = this.props.photoProject || {};

        this.$projectLink.attr('href', url);
        this.$projectName.text(name);
        return this;
    },

    /**
     * Updates photo's attribute tags
     * @returns {PhotoDetails}
     * @private
     */
    _updatePhotoAttributeTags() {
        const {photoAttrTags = []} = this.props;
        const links = photoAttrTags.map(
            ({url, value}) => `<a href="${url}" target="_blank">${value}</a>`
        );
        this.$photoAttributes.html(links.join('<span>, </span>'));

        return this;
    },

    _onClickProjectLink() {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, {target: GA_LINK_TARGETS.PROJECT});
    },
    _onClickMoreProjectsLink() {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, {target: GA_LINK_TARGETS.MORE});
    },
    _onClickSimilarItemsLink(e) {
        this.context.executeAction(galleryTrackingActions.trackLinkClick, {
            target: GA_LINK_TARGETS.VIEW_SIMILAR,
            label: e.currentTarget.href
        });
    },
    _onClickSimilarItem(e) {
        this.context.executeAction(galleryTrackingActions.trackSimilarItemClick, e.currentTarget.dataset);
    }
});

module.exports = PhotoDetails;



// WEBPACK FOOTER //
// ./assets/js/gallery/views/PhotoDetails.es.js